import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ForuscareService } from '../foruscare/foruscare.service';
import { User } from '../../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private handleError: HandleError;
  constructor(
    public http: HttpClient,
    public fourscareService: ForuscareService,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('User Service');
  }

  loginUser(credential): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/oauth/token", "grant_type=" + encodeURIComponent("password") + "&client_id=" + encodeURIComponent("restapp") + "&client_secret=" + encodeURIComponent("restapp") + "&username=" + encodeURIComponent(credential.email) + "&password=" + encodeURIComponent(credential.password))
      .pipe(
        catchError(this.handleError('user login'))
      );
  }
  loginWithCaptcha(credential): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/captcha/login", credential)
      .pipe(
        catchError(this.handleError('user login'))
      );
  }
  logoutUser(email): Observable<any> {
    // return this.http.get<any>(this.fourscareService.baseAuthURL() + "/authentication/logout?userId="+email)
    //   .pipe(
    //     catchError(this.handleError('user login'))
    //   );
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/authentication/logoff?userId=" + email)
      .pipe(
        catchError(this.handleError('user login'))
      );
  }
  sendResetPasswordLink(email: string): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/password/mailtrigger/?userId=" + email)
      .pipe(
        catchError(this.handleError('reset password link'))
      );
  }
  // sendResetPasswordLinkWithCaptha(email: string): Observable<any> {
  //   return this.http.get<any>(this.fourscareService.baseAuthURL() + "/password/captcha/mailtrigger/?userId=" + email)
  //     .pipe(
  //       catchError(this.handleError('reset password link'))
  //     );
  // }

  sendResetPasswordLinkWithCaptcha(payload: { userId: string; captchaToken: string; manualCaptcha: boolean }): Observable<any> {
    return this.http.post<any>(
      this.fourscareService.baseAuthURL() + "/password/captcha/mailtrigger",
      payload
    ).pipe(
      catchError(this.handleError('reset password link'))
    );
  }


  resetPassword(data): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/password/forgotpassword/", data)
      .pipe(
        catchError(this.handleError('update password'))
      );
  }

  checkEmailExists(email: string): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/checkEmail/" + email + "/")
      .pipe(
        catchError(this.handleError('reset password link'))
      );
  }

  checkMobileExists(mobile: string): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/checkPhoneNumber/" + mobile + "/")
      .pipe(
        catchError(this.handleError('reset password link'))
      );
  }

  getIncentivePlanByUserId(userId: string): Observable<any> {
    return this.http.get(this.fourscareService.hostUrl + "/EssilorIncentive/api/userIncentive/user/" + userId)
      .pipe(
        catchError(this.handleError('incentive config by id'))
      );
  }

  createUser(user: User): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAdminURL() + "/user", user)
      .pipe(
        catchError(this.handleError('user creation'))
      );
  }

  updateUser(user: User, userId): Observable<any> {
    return this.http.put<any>(this.fourscareService.baseAdminURL() + "/user/" + userId, user)
      .pipe(
        catchError(this.handleError('user updation'))
      );
  }
  resetUserPassword(obj): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/authentication/resetPassword", obj)
      .pipe(
        catchError(this.handleError('user password reset'))
      );
  }
  submitOTP(otp): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/validateOTP/" + otp)
      .pipe(
        catchError(this.handleError('submit OTP'))
      );
  }
  resendOTP(): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/resendOTP")
      .pipe(
        catchError(this.handleError('resend OTP'))
      );
  }
  getAdminUsers(): any {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/getAdminUsers")
      .pipe(
        catchError(this.handleError('listing admin users'))
      );
  }

  getAdminUsersPaging(count, offset): any {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/getAdminUsers?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError('listing admin users'))
      );
  }

  getUserInfoById(userId): any {
    return this.http.get<any>(this.fourscareService.baseAdminURL() + "/user/getUserInfo/" + userId)
      .pipe(
        catchError(this.handleError('user info by id'))
      );
  }

  getClientKeys(count: any, offset: any): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/client-keys?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError('Error to get client keys'))
      );
  }

  generateClientKey(accountId: number, clientName: string): Observable<any> {
    let payloadData = {
      "accountId": accountId,
      "clientName": clientName
    }
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/client-keys/generate-update", payloadData)
      .pipe(
        catchError(this.handleError('Error to save client key'))
      );
  }

  setClientKeyStatus(status: string, clientKeyId: any): Observable<any> {
    const url = `${this.fourscareService.baseAuthURL()}/client-keys/${clientKeyId}?action=${status}`;
    return this.http.put<any>(url, "")
      .pipe(
        catchError(this.handleError('Error to save client key'))
      );
  }

  // adminUsersSearch(searchValue: string, columnName: any): Observable<any> {
  //   const url = `${this.fourscareService.baseAuthURL()}/admin/user/account/users/searchFilter?count=10&offset=0&searchBy=${searchValue}&filterBy=${columnName}`;
  //   return this.http.get<any>(url)
  //   .pipe(
  //     catchError(this.handleError('Error to save client key'))
  //   );
  // }

  adminUsersSearch(searchValue: string, columnName: any, count: any, offset: any): Observable<any> {
    if (!count)
      count = 10;
    if (!offset)
      offset = 0;
    const encodedSearchBy = encodeURIComponent(searchValue);
    const url = `${this.fourscareService.baseAuthURL()}/admin/user/account/users/searchFilter?count=${count}&offset=${offset}&searchBy=${encodedSearchBy}&filterBy=${columnName}`;

    return this.http.get<any>(url)
      .pipe(
        catchError(this.handleError('Error to get client keys'))
      );
  }

  serviceProvidersSearch(searchValue: string, columnName: any, count, offset): Observable<any> {
    if (!searchValue) {
      searchValue = "";
    }
    if (!columnName) {
      columnName = "";
    }
    const encodedSearchBy = encodeURIComponent(searchValue);
    const url = `${this.fourscareService.baseAuthURL()}/serviceProvider/allProviders/searchFilter?count=${count}&offset=${offset}&searchBy=${encodedSearchBy}&filterBy=${columnName}`;

    return this.http.get<any>(url)
      .pipe(
        catchError(this.handleError('Error to get client keys'))
      );
  }

  devicesSearch(searchValue: string, columnName: any, count: any, offset: any): Observable<any> {
    if (!searchValue)
      searchValue = '';
    if (!columnName)
      columnName = '';
    if (!count)
      count = 10;
    if (!offset)
      offset = 0;
    const url = `${this.fourscareService.baseAuthURL()}/admin/device/allDevices/searchFilter?limit=${count}&offset=${offset}&searchBy=${searchValue}&filterBy=${columnName}`;

    return this.http.get<any>(url)
      .pipe(
        catchError(this.handleError('Error to get client keys'))
      );
  }

  offlinePaymentSearch(searchValue: string, columnName: any): Observable<any> {
    const url = `${this.fourscareService.baseAuthURL()}/admin/payment/offline/searchFilter?count=10&offset=0&searchBy=${searchValue}&filterBy=${columnName}`;

    return this.http.get<any>(url)
      .pipe(
        catchError(this.handleError('Error to get client keys'))
      );
  }

  accountSearch(searchValue: string, columnName: any, count, offset): Observable<any> {
    if (!offset)
      offset = 0;
    else if (!searchValue)
      searchValue = '';
    else if (!columnName)
      columnName = '';
    const url = `${this.fourscareService.baseAuthURL()}/accounts/searchFilter?count=${count}&offset=${offset}&searchBy=${searchValue}&filterBy=${columnName}`;

    return this.http.get<any>(url)
      .pipe(
        catchError(this.handleError('Error to get client keys'))
      );
  }

  searchByAccountNameOrClientName(accountName: string, clientName: string, count: number, offset:number): Observable<any> {
    let payloadData = {
      "filterBy": accountName,
      "filterValue": clientName,
      "count": count,
      "offset": offset
    }
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/client-keys/searchFilter", payloadData)
      .pipe(
        catchError(this.handleError('Error to save client key'))
      );
  }

}
